module.exports = __webpack_public_path__ + "img/20.35bd63a6.svg";